import { useState, useEffect, useMemo } from 'react';

export function useTypingAnimation(sentences, { typeSpeed = 100, pauseDuration = 1000 } = {}) {
  const [typedText, setTypedText] = useState('');
  const [sentenceIndex, setSentenceIndex] = useState(0);

  const colors = useMemo(() => ['#6B8AFF', '#4A6CF7'], []);
  const currentColor = colors[sentenceIndex % colors.length];

  useEffect(() => {
    const currentSentence = sentences[sentenceIndex];

    if (typedText.length < currentSentence.length) {
      const timeout = setTimeout(() => {
        setTypedText(currentSentence.slice(0, typedText.length + 1));
      }, typeSpeed);
      return () => clearTimeout(timeout);
    } else {
      const timeout = setTimeout(() => {
        setTypedText('');
        setSentenceIndex((prev) => (prev + 1) % sentences.length);
      }, pauseDuration);
      return () => clearTimeout(timeout);
    }
  }, [typedText, sentenceIndex, sentences, typeSpeed, pauseDuration]);

  return { typedText, currentColor };
}
